import React from 'react';

type Props = {
  size: number;
};

export const Horizontal = ({size}: Props) => <div style={{ width: size }} />;
export const Vertical = ({size}: Props) => <div style={{ height: size }} />;
